import React from 'react';
import LinearProgressBar from '../progress-bar/Progress';
import CancelIcon from '@material-ui/icons/Cancel';
import { IconButton, Button, Tabs, Tab } from '@material-ui/core';

const CustomFormView = (props) => {
  const {
    handleSubmit,
    tabTitle,
    onCancel,
    children,
    isTabInValid,
    tabValue,
    maxtab,
    isUpdate,
    loading,
    handleTabChange,
    title,
    onClickNext,
    titleClass,
    tabClass,
    cancelClass,
    validLimit,
    hasVideoError,
    isThumbnailUploading,
    isVideoLoading,
    isGifLoading,
  } = props;

  const setButtonTitle = () => {
    if (tabValue < maxtab) return 'Next';
    if (isUpdate) return 'Update';
    else return 'Add';
  };

  const onClickButton = (e) => {
    if (tabValue < maxtab) return onClickNext();
    else handleSubmit(e);
  };

  return (
    <form className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className={titleClass}>
            <span className='page-title'>{title}</span>
          </div>
          {tabTitle.length > 0 && (
            <div className={tabClass}>
              <Tabs
                value={tabValue}
                variant='fullWidth'
                indicatorColor='primary'
                onChange={handleTabChange}
                aria-label='category-add-tabs'
                textColor='primary'
                className='property-tabs'
              >
                {tabTitle.map((tabKey, tabNdx) => (
                  <Tab key={tabNdx} label={tabKey} />
                ))}
              </Tabs>
            </div>
          )}
          <div className={`${cancelClass} d-flex justify-content-end`}>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4'>{children}</div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              color='primary'
              onClick={(e) => onClickButton(e)}
              size='large'
              className='me-3'
              disabled={isTabInValid || validLimit || loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
            >
              {setButtonTitle()}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default CustomFormView;
